/**
 * SaleRegisterContainer
 * --
 */
import React from 'react';
import SaleRegisterPresenter from './SaleRegisterPresenter';
import { useUserStack } from 'store';

import { useGetMenus } from 'hooks/MenuHooks';
import { useGetUsers } from 'hooks/UserHooks';
import { useGetShopInformations } from 'hooks/ShopInformationHooks';
import { useGetShopMenus } from 'hooks/ShopMenuHooks';
import { useGetProductCategories } from 'hooks/ProductCategoryHooks';

const INITIAL_VALUES = {
  user_phone: null,
  shop_information_id: null,
  product_information: [],
};
const SaleRegisterContainer = () => {
  const userInfo = useUserStack();
  const auth = userInfo?.type;
  const defaultShopId = userInfo?.shop_information_id;
  const options = {
    gcTime: Infinity,
    // staleTime: Infinity,
    select: (res) => {
      const { status, data } = res;

      if (status !== 200) return [];
      else return data;
    },
    initialData: [],
  };

  //   const { data: shopInformation, refetch: shopInformationRefetch } =
  //   useGetShopInformation(userStack?.shop_information_id);
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [inputValue, setInputValue] = React.useState(INITIAL_VALUES);
  const [selectedUserPhone, setSelectedUserPhone] = React.useState(null);
  const [userData, setUserData] = React.useState(null);
  const [selectedList, setSelectedList] = React.useState([]);
  const [amountList, setAmountList] = React.useState([]);
  const [modalType, setModalType] = React.useState('MENU');
  const [isOpen, setIsOpen] = React.useState(false);

  console.log('inputValue', inputValue);
  console.log('isOpen', isOpen);
  console.log('modalType', modalType);
  console.log('selectedList', selectedList);
  /* ===== VARIABLE ===== */

  const { data: MenuList } = useGetMenus({
    join_tables: '["product_category"]',
  });
  //
  const { data: user } = useGetUsers(
    { user_phone: selectedUserPhone },
    {
      enabled: selectedUserPhone !== null,
    }
  );
  //
  const { data: ShopList } = useGetShopInformations(
    {
      application_status: 'APPROVE',
      type: 'STORE',
      //매장 관리자 해당 매장만 조회
      ...(auth !== 'ADMIN' && {
        shop_information_id: userInfo?.shop_information_id,
      }),
    },
    options
  );
  // NOTE: 상품 카테고리 데이터 호출
  const { data: Categories } = useGetProductCategories(
    { type: 'MENU' },
    {
      initialData: [],
      select: (res) => {
        const { status, data } = res;

        if (status !== 200) return [];

        return data;
      },
    }
  );

  const { data: ShopMenuList } = useGetShopMenus({
    shop_information_id: inputValue?.shop_information_id ?? 2,
    is_show: 'Y',
  });

  const menuList = React.useMemo(() => {
    const shopMenus = ShopMenuList?.data;
    return MenuList?.data
      ?.filter((m) => shopMenus?.some((sm) => sm?.menu_id === m?.menu_id))
      .map((m) => {
        const matchedCategory = Categories?.find(
          (c) => c?.product_category_id === m?.product_category_id
        );
        console.log(matchedCategory);
        return {
          key: m?.menu_id,
          product_category_name: matchedCategory?.product_category_name,
          ...m,
        };
      });
  }, [MenuList?.data, ShopMenuList?.data, Categories]);

  const shopList = React.useMemo(() => {
    return ShopList;
  }, [ShopList]);

  // console.log('selectedUserPhone', selectedUserPhone);
  // console.log(user);
  /* ===== FUNCTION ===== */
  /**
   * 데이터 바인딩 함수
   * --
   */
  const handleChange = (t, v, callback = null) => {
    let newData = { ...inputValue };

    newData[t] = v;
    const d = {
      ...newData,
    };
    setInputValue(d);

    if (callback) callback(v);
  };

  /**
   * 회원 선택 핸들러
   * --
   * @param {string} type
   * @param {object | array} obj
   */
  const handleSelect = (type, obj) => {
    const selectType = type.toLocaleUpperCase();

    switch (selectType) {
      case 'CHECKED': // 개별 선택
        setSelectedList((prev) => [...prev, obj]);
        return;
      case 'UNCHECKED': // 개별 선택 해제
        setSelectedList((prev) =>
          prev.filter((select) => select.key !== obj.key)
        );
        return;
      case 'ALL-CHECKED': // 노출된 목록 전체 선택
        setSelectedList(obj);
        return;
      case 'ALL-UNCHECKED': // 노출된 목록 전체 선택 해제
        const removeList = selectedList.filter((user) =>
          obj.some((ob) => ob.key === user.key)
        );

        setSelectedList(removeList);

        return;
      case 'ALL': // 검색된 회원 전체 선택/해제
        const isAll = selectedList.length === obj.length;

        if (!isAll) {
          setSelectedList(obj);
        } else {
          setSelectedList([]);
        }
        return;
      default:
        return;
    }
  };
  /* ===== HOOKS ===== */
  /** 회원 조회
   * --
   */
  React.useEffect(() => {
    if (user?.data) {
      setUserData(user?.data?.[0]);
    }
  }, [user?.data]);

  React.useEffect(() => {
    if (auth === 'ADMIN') {
      setInputValue(INITIAL_VALUES);
    } else {
      setInputValue({
        ...INITIAL_VALUES,
        shop_information_id: defaultShopId,
      });
    }
  }, []);
  /* ===== RENDER ===== */
  return (
    <>
      <SaleRegisterPresenter
        menuList={menuList}
        userData={userData}
        shopList={shopList}
        categoryList={Categories}
        //함수
        onChange={handleChange}
        selectedList={selectedList}
        onSelect={handleSelect}
        modalType={modalType}
        onModalType={setModalType}
        isOpen={isOpen}
        onIsOpen={setIsOpen}
        amountList={amountList}
        onAmountList={setAmountList}
        ////

        inputValue={inputValue}
        selectedUserPhone={selectedUserPhone}
        onSelectedUserPhone={setSelectedUserPhone}
      />
    </>
  );
};

export default SaleRegisterContainer;
